import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const AdmissionGuidelines = () => {
    useEffect(() => {
        document.title = 'Admission Guidelines -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Admission Guidelines </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Admission</li>
                            <li>|</li>
                            <li> Admission Guidelines </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-12 admissionguid'>
                    <h1 className="head1"> Admission Guidelines (Academic Year 2026–2027)</h1>
                        <h4 className="head1"> 1 How to Apply (Online Registration)</h4>
                           <p>  All applications must be submitted online only through the official school portal.</p>
                         <ul>
                            <li>  Official Portal: <a href="https://shsb.campussoft.net" target="_blank">https://shsb.campussoft.net</a> </li>
                            <li>  Valid Contact Details: Parents must provide an active email ID and mobile number for all communication related to admission, interaction, and results. </li>
                         </ul>
                         <h4 className="head1"> 2 Age Eligibility (As per NEP 2020 Guidelines) </h4>
                         <div class="table-responsive">
                         <table class="table maintable"> 
                           <tbody>  
                                 <tr>
                                     <td className="classbg"><b> Class</b></td> 
                                     <td className="classbg"><b> Minimum Age as on 1 April 2026</b></td> 
                                     <td className="classbg"><b> Assessment Method</b></td> 
                                 </tr>
                               <tr>
                                  <td>LKG</td>
                                  <td>4 years or older</td>
                                  <td>No written test; interaction with both parents mandatory</td>
                              </tr>
                              <tr>
                                  <td>UKG & Above</td>
                                  <td>As per NEP norms for respective class</td>
                                  <td>Written Test (English & Mathematics) + Interview</td>
                              </tr>
                          </tbody>
                         </table> 
                      </div>
                      <h4 className="head1"> 3  Application Details & Required Uploads </h4>
                            <div className="row">
                                <div className="col-lg-6">
                                     <div className="admissionbox">
                                            <p><b>For LKG Applicants</b></p>
                                            <ul>
                                            <li> Assessment: No written test; interaction with both parents. </li>
                                            </ul>
                                            <p>Documents to Upload:</p>
                                                <ul>
                                                <li> Child’s recent photograph (≤ 50 KB) </li>
                                                <li> Birth certificate (PDF ≤ 20 KB) </li>
                                                </ul>
                                     </div>
                                 </div>
                                 <div className="col-lg-6">
                                     <div className="admissionbox">
                                            <p><b> For UKG & Above Applicants</b></p>
                                            <ul>
                                            <li>   Assessment: Written test (English & Mathematics) followed by interview.</li>
                                            </ul>
                                            <p>Documents to Upload:</p>
                                            <ul>
                                            <li>   Child’s recent photograph (≤ 50 KB)</li>
                                            <li>   Latest marksheet</li>
                                            <li>  Previous school fee receipt</li>
                                            </ul>
                                    </div>
                                 </div>
                            </div>
                            <h4 className="head1"> 4 After Applying — The Selection Process   </h4>
                            <div className="row">
                               <div className="col-lg-4">
                                  <div className="admissionbox">
                                          <p><b>Step 1 – Notification</b></p>
                                          <p>Upon successful form submission and payment, parents will receive Email and SMS with the date, time, and venue for the test or interaction.</p>
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="admissionbox">
                                          <p><b>Step 2 – Attendance</b></p>
                                          <p> Parents and applicants must report punctually. No re-test or re-interaction will be conducted.</p>
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="admissionbox">
                                          <p><b>Step 3 – Selection Announcement</b></p>
                                          <p> The list of selected candidates will be displayed at the school campus. Only selected candidates will receive SMS confirmation. The school is not responsible for delivery issues or SMS delays.</p>
                                  </div>
                                </div>
                             </div> 

                             <h4 className="head1"> 5 Documents Required After Selection   </h4>
                             <p>Parents must submit the following for verification within the specified timeframe.</p>
                             <div className="row">
                             <div className="col-lg-6">
                             <div className="admissionbox">
                             <p><b>For LKG </b></p>
                             <ul>
                             <li> Medical certificate of fitness </li>
                             <li> Affidavit confirming correctness of details </li>
                             <li> Valid email ID and mobile number </li>
                             <li> Original Birth Certificate (for verification) + photocopy </li>
                             <li> Aadhaar card (photocopy) </li>
                             </ul>
                             </div>
                             </div>
                             <div className="col-lg-6">
                             <div className="admissionbox">
                             <p><b>For UKG & Above </b></p>
                             <p>All LKG documents plus:</p>
                             <ul>
                             <li> Transfer Certificate (TC) / School Leaving Certificate </li>
                             <li> To be submitted on the day of admission </li>
                             <li> For out-of-state students, TC must be countersigned by the competent education authority </li>
                             <li> Permanent Education Number (PEN) </li>
                             <li> APAAR ID (for details, contact school office) </li>
                             <li> Latest marksheet </li>
                             </ul>
                             </div> 
                             </div>
                             </div>
                             <h4 className="head1">6 Final Admission Confirmation  </h4>
                             <p>Admission is confirmed only after completion of all the following steps: <br/>
                             1. Verification of all submitted documents <br/>
                             2. Submission of all required certificates <br/>
                             3. Full payment of school fees </p>
                             
                             <p><strong>Note: Providing false or invalid documents will result in immediate cancellation of admission.M</strong></p>
                             <h4 className="head1">7 Other Important Information </h4>
                                        <p>For queries or assistance during the online registration process:</p>

                                        <div class="table-responsive">
                                        <table class="table maintable"> 
                                        <tbody>  
                                            <tr>
                                                <td className="classbg"><b> Policy</b></td> 
                                                <td className="classbg"><b> Details</b></td>  
                                            </tr>
                                            <tr>
                                                    <td>Application Fee</td>
                                                    <td>Non-refundable</td>
                                                </tr>
                                                <tr>
                                                    <td>Admission Guarantee</td>
                                                    <td>Submission of an application form does not guarantee admission</td>
                                                </tr>
                                                <tr>
                                                    <td>Deadlines</td>
                                                    <td>All formalities must be completed within the notified time; otherwise, the seat will be forfeited</td>
                                                </tr>
                                                <tr>
                                                    <td>Non-Selected Applicants</td>
                                                    <td>Requests for re-consideration will not be entertained</td>
                                                </tr>
                                                <tr>
                                                    <td>Final Decision</td>
                                                    <td>The management reserves full right to grant or deny admission. Decision is final and binding.</td>
                                                </tr>
                                        </tbody>
                                        </table> 
                                        </div>

                             <h4 className="head1">8 Help & Support   </h4>
                                    <p>For queries or assistance during the online registration process:</p>

                                    <div class="table-responsive">
                                    <table class="table maintable"> 
                                    <tbody>  
                                        <tr>
                                            <td className="classbg"><b> Contact Type</b></td> 
                                            <td className="classbg"><b> Details</b></td>  
                                        </tr>
                                    <tr>
                                            <td>Principal’s Email</td>
                                            <td>principalsacredheartschool@gmail.com</td>
                                        </tr>
                                        <tr>
                                            <td>ENTAB Parent Help Desk</td>
                                            <td>+91-92402-58383</td>
                                        </tr>
                                    </tbody>
                                    </table> 
                                    </div>
                             <h4 className="head1">9 Document Checklist Summary   </h4>
                             <div className="row">
                             <div className="col-lg-4">
                             <div className="admissionbox">
                             <p><b>At the Time of Online Application</b></p>
                             <ul>
                                 <li> Child’s photograph (≤ 50 KB) </li>
                                 <li> Birth certificate / Latest marksheet (as applicable) </li>
                                 <li> Previous school fee receipt (for UKG & above) </li>
                             </ul>
                             </div>
                             </div>
                             <div className="col-lg-4">
                             <div className="admissionbox">
                             <p><b>After Selection </b></p> 
                             <ul>
                                 <li> Passport-size photos (child + parents) </li>
                                 <li> Medical fitness certificate </li>
                                 <li> Affidavit of correctness </li>
                                 <li> Birth certificate (original + copy) </li>
                                 <li> Aadhaar card (copy) </li>
                                 <li> TC / PEN / APAAR (for UKG & above) </li>
                                 <li> Registration form printout </li>
                             </ul>
                             </div> 
                             </div>
                             <div className="col-lg-4">
                             <div className="admissionbox">
                                 <p><b>Final Stage </b></p> 
                             <ul>
                             <li> Verification complete </li>
                             <li> Full fee payment made </li>
                             </ul>
                             </div>
                             </div>
                             </div>
                             <p>Admission procedures are subject to revision in accordance with NEP-2020 and School Management policies. Parents are advised to follow the school website and official communication for updates.</p>
                     </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default AdmissionGuidelines